import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M3 11l.1487.0055C4.18 11.0822 5 11.95 5 13v7c0 1.1-.9 2-2 2l-.1487-.0055C1.82 21.9178 1 21.05 1 20v-7c0-1.1.9-2 2-2zm5.6 0c.24 0 .48.04.7.13l6.92 2.58c.46.18.77.62.77 1.11l-.0061.1204C16.9233 15.5342 16.4194 16 15.81 16h-2.63c-.12 0-.25-.03-.36-.07l-1.12-.43c-.26-.1-.55.04-.64.3l-.022.0871c-.0375.2328.0909.4629.322.5429l1.47.51c.11.04.22.06.33.06h6.83c1.11 0 2.01.89 2.01 2l-7.38 2.78c-.4.15-.84.17-1.25.05L7 20.02V11zm10.1-9C20.55 2 22 3.45 22 5.3c0 2.1-2.5 4.51-5.33 7.09-.38.35-.97.35-1.35 0C12.5 9.81 10 7.4 10 5.3 10 3.45 11.45 2 13.3 2c1.04 0 2.05.49 2.7 1.25.65-.76 1.66-1.25 2.7-1.25z"
  }],
  circles: []
};
var VolunteerActivismIcon = function VolunteerActivismIcon(props) {
  return renderIcon(props, iconType);
};
export { VolunteerActivismIcon };